/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from '@mui/material/Box';
import { useStyles } from './styles';
import Thumbnail from '../components/thumbnail';
import CommonImages from '../../commons/images';
import { createImage } from '../../commons/images';
function Tile (props) {
    const {
        widget = {},
        data = {},
        widgetTheme = {},
        onClick = () => {},
        selected = false,
        id = '',
    } = props;

    const [source, setSource] = useState(CommonImages.LOADER);
    const classes = useStyles({
        widget,
        widgetTheme,
    });

    useEffect(() => {
        preloadImage();
    }, [data]);

    async function preloadImage () { 
        if (data.logo) {
            await createImage(data.logo);
            setSource(data.logo);
        } else {
            setSource(CommonImages.DEFAULT_SCHEDULE_LOGO);
        }
    }

    function renderThumbnail (data) {
        return (
            <Box className={classNames([classes.tileBox, selected && 'schedule-selected'])}>
                <img
                    className={classes.tile}
                    alt={data.name}
                    src={source}
                />
            </Box>
        );
    }

    return (
        <Thumbnail
            id={id}
            data={data}
            view={'schedule'}
            widget={widget}
            widgetTheme={widgetTheme}
            label={data.name}
            renderThumbnail={renderThumbnail}
            onClick={() => {
                onClick(data);
            }}
            checkCustomClassName={'ecal-schedule-check'}
            labelCustomClassName={'ecal-schedule-selected'}
            selected={selected} 
        />
    );
}

Tile.propTypes = {
    index: PropTypes.number,
    data: PropTypes.any,
    widget: PropTypes.any,
    widgetTheme: PropTypes.any,
    onClick: PropTypes.func,
    selected: PropTypes.bool,
    id: PropTypes.string,
};

export default Tile;